// extracted by mini-css-extract-plugin
module.exports = {"problem-inside-suggestion":"suggestion-dropdown_problem-inside-suggestion__nWk4O"};